// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3DDyK","label":"SetPasswdForm_label__3cRyY"};